import { useEffect, useState } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { CheckboxOptionType, Typography } from 'antd';
import * as ProviderActionCreators from '../../store/actions/providerAction';
import * as CountriesActionCreators from '../../store/actions/countryAction';
import * as PerformanceReportActionCreators from '../../store/actions/performanceReportAction';
import { RootState } from '../../store/reducers';
import { errorNotify } from '../common/Notify';
import PerformanceReportTable from './PerformanceReportTable';
import PerformanceReportBar from './PerformanceReportBar';

const { Title } = Typography;

const mapStateToProps = (state: RootState) => ({
    userState: state.user,
    countryState: state.country,
    providerState: state.provider,
    performanceReportState: state.performanceReport,
});

const mapDispatchToProps = (dispatch: Dispatch) => {
    const boundActions = bindActionCreators({
        ...ProviderActionCreators,
        ...CountriesActionCreators,
        ...PerformanceReportActionCreators,
    }, dispatch);
    return {
        ...boundActions,
    };
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

type ProviderProps = StateProps & DispatchProps;

const PerformanceReport: React.FC<ProviderProps> = props => {
    const { userState, countryState, providerState, performanceReportState } = props;
    const { groups } = userState;
    const { countries, error: errorCountry } = countryState;
    const { providersList, error: errorProvider } = providerState;
    const { performanceStats, error: errorPerformanceReport, loading } = performanceReportState;
    const { fetchCountries, fetchProvidersList, fetchPerformanceReport } = props;
    const groupByOptions: Record<string, string> = {
        region: 'Region',
        kind_app: 'API',
        traffic_distribute_mode: 'Traffic distribute mode',
        country: 'Country',
        country_by_device: 'Country by Device',
        application: 'Bundle',
        provider: 'Provider',
        user_category: 'User category',
        zone: 'Zone',
        user_consent: 'User consent',
        user_ip: 'User IP',
        tmax: 'Tmax',
        campaign: 'Campaign',
        channel: 'Channel',
        purposes_consent: 'Purposes',
        purposes_li_consent: 'Purposes LI',
        vendors_consent: 'Vendors',
        vendors_li_consent: 'Vendors LI',
    };
    const [groupByList, setGroupByList] = useState<string[]>([]);
    const onGroupByChange = (checkedValues: CheckboxOptionType[]) => {
        setGroupByList(checkedValues.map(item => item.toString()));
    };

    useEffect(() => {
        fetchCountries();
        fetchProvidersList();
    }, []);

    useEffect(() => {
        if (errorCountry) errorNotify('Country error', errorCountry);
    }, [errorCountry]);

    useEffect(() => {
        if (errorProvider) errorNotify('Provider error', errorProvider);
    }, [errorProvider]);

    useEffect(() => {
        if (errorPerformanceReport) errorNotify('Performance report error', errorPerformanceReport);
    }, [errorPerformanceReport]);

    return (
        <>
            <Title level={2} className="title">Performance Report</Title>
            <PerformanceReportBar
                fetchPerformanceReport={fetchPerformanceReport}
                performanceStats={performanceStats}
                countriesList={countries}
                providersList={providersList}
                groupByOptions={groupByOptions}
                onGroupByChange={onGroupByChange}
            />
            <PerformanceReportTable
                loading={loading}
                error={errorPerformanceReport}
                performanceStats={performanceStats}
                groupByList={groupByList}
                groups={groups}
            />
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceReport);
